var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLowerJ(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 267,
    viewBox: "0 0 65 267",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.3836 0.199986C44.7836 0.199986 38.4836 6.49999 38.4836 13.1C38.4836 19.7 44.7836 26 51.3836 26C57.9836 26 64.2836 19.7 64.2836 13.1C64.2836 6.49999 57.9836 0.199986 51.3836 0.199986ZM42.3836 181.7C42.3836 196.1 40.2836 209.6 36.6836 220.7C32.7836 232.4 26.4836 241.4 18.6836 245.9C14.1836 248.6 9.08359 250.1 0.683593 250.7L1.88359 266.3C12.3836 266 20.1836 263.6 26.7836 259.7C37.8836 253.1 47.1836 240.8 51.9836 225.8C56.1836 213.2 58.2836 197.9 58.2836 181.7V41.3H42.3836V181.7Z",
    fill: "#FEC736"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerJ);
export default __webpack_public_path__ + "static/media/LOWER_J.3cd09d8ec943cd4049c5c193e9f0229e.svg";
export { ForwardRef as ReactComponent };